/** Read scroll position and scrollable range across browser/layout quirks. */
export function scrollMetrics(): { scrollTop: number; scrollable: number; pct: number } {
  const doc = document.documentElement;
  const scrollTop = Math.max(window.scrollY, doc.scrollTop, document.body.scrollTop);
  const scrollHeight = Math.max(doc.scrollHeight, document.body.scrollHeight);
  const clientHeight = window.innerHeight;
  const scrollable = scrollHeight - clientHeight;

  if (scrollable <= 0) {
    return { scrollTop, scrollable: 0, pct: 100 };
  }

  const pct = Math.min(100, Math.round((scrollTop / scrollable) * 100));
  return { scrollTop, scrollable, pct };
}
